import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import * as model from "../../../../models"

@Component({
	selector: 'visual-tickets',
	templateUrl: "./visual-tickets.presentation.html",
	styles: [require("./visual-tickets.presentation.scss")],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisualTickets {
	@Input() visualTickets: model.DisplayTicket[] = [];
	@Output() removeTickets = new EventEmitter<string[]>();
	@Output() navigateToSeatingPlanClicked = new EventEmitter<void>();
}



// WEBPACK FOOTER //
// ./src/app/components/box-office/sp-ticket-categories-box-office/visual-tickets/visual-tickets.presentation.ts